import { z } from "zod";
export const DTOCodeScanUploadedBy = z.object({
    userId: z.string(),
    name: z.string(),
    avatar: z.string().optional(),
});
export const DTOCodeScanListItem = z.object({
    scanId: z.string(),
    scanTimestamp: z.string(),
    packageNames: z.array(z.string()),
    repositoryName: z.string(),
    uploadedBy: DTOCodeScanUploadedBy.optional(),
    cliVersion: z.string().optional(),
});
export const DTOCodeScanListResponse = z.object({
    scans: z.array(DTOCodeScanListItem),
});
export const DTOCodeScanDeleteResponse = z.object({
    ok: z.literal(true),
});
